import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { RequestSelect } from '../../../../Request'
import { TASK_FORM_SERVICE_REQUEST_FIELD_NAME } from '../../TaskForm.constants'

function ServiceRequestField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      closeDropdownOnClear
      shouldConfirmClear
      Component={FormFieldSelectNG}
      Select={RequestSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Task.FormServiceRequestFieldPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Task.FormServiceRequestFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={TASK_FORM_SERVICE_REQUEST_FIELD_NAME}
    />
  )
}

export default ServiceRequestField
